export const AuditUploadMessage =
  "The audit will be allocated to the company assigned as the site owner. An alternative audit owner can be selected below (optional).";
